import { omitKeys } from 'lib/object/objectUtils'
import { isBedbankOffer, isLEHotel, isTourV1Offer, isVillaOffer } from './offerTypes'
import getTacticalPricePackage from './getTacticalPricePackage'

/** Apply the same listing boundary to summary responses and full-offer fallbacks. */
export default function convertOfferToListingOffer(offer: App.AnyOffer): App.ListingOffer {
  if (isBedbankOffer(offer)) {
    const summary = 'description' in offer ? omitKeys(['description', 'metaDescription', 'attractions', 'facilityGroups'], offer) : offer
    return {
      ...summary,
      packages: [],
    }
  }
  if (isLEHotel(offer) || isTourV1Offer(offer) || isVillaOffer(offer)) {
    const summary = omitKeys(['highlights', 'whatWeLike', 'facilities', 'finePrint', 'gettingThere'], offer)
    if (isLEHotel(offer)) {
      const fallbackInclusions = offer.packages.find(pkg => pkg.inclusions?.length)?.inclusions
      let tileInclusions = offer.tileInclusions
      if (!tileInclusions?.length && !offer.lowestPricePackage?.inclusions?.length) {
        tileInclusions = fallbackInclusions?.filter(inclusion => inclusion.displayContext === 'Rate')
      }
      return {
        ...summary,
        tacticalPricePackage: getTacticalPricePackage(offer),
        tileInclusions,
        availableDurations: offer.availableDurations ?? [...new Set(offer.packages.map(pkg => pkg.duration))],
        packages: [],
      }
    }
    return {
      ...summary,
      packages: [],
    }
  }
  return offer
}
